import tokenSaga, { deleteToken, generateToken, getToken } from '~/sagas/token/token.saga';

export default tokenSaga;

export { generateToken, getToken, deleteToken };
